import { render } from "./BottomBanner.vue?vue&type=template&id=122ef600&scoped=true"
import script from "./BottomBanner.vue?vue&type=script&lang=js"
export * from "./BottomBanner.vue?vue&type=script&lang=js"

import "./BottomBanner.vue?vue&type=style&index=0&id=122ef600&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122ef600"]])

export default __exports__